import { useTranslation } from "@luckymenu/i18n/react";

/** The clover mark and name. `compact` shows the mark only, for the rail. */
export function Brand({ compact = false }: { compact?: boolean }) {
	const { t } = useTranslation();
	return (
		<span className="flex items-center gap-2 font-semibold text-foreground">
			<img src="/favicon.svg" alt={compact ? t("appName") : ""} className="size-8" />
			{compact ? null : <span className="text-lg">{t("appName")}</span>}
		</span>
	);
}
